import * as Yup from 'yup';
import ACCIDENT_PARTICIPANT_TYPES from '../../../containers/CascoCompensationContainer/options';
import { APPLICANT_TYPES } from '../../../constants/claim';
import { getLegalEntityValidator, getPhysicalEntityValidator } from '../claimApplicantDetailsValidation';
import { isArmenianCountry } from '../../../helpers/countryHelper';

const legalSchema = Yup.object()
  .shape({
    hvhh: Yup.string()
      .matches(/^[\d]{8}$/, 'validationErrors.eightDigitsOnly')
      .required('validationErrors.isRequired'),
    organizationName: Yup.string()
      .required('validationErrors.isRequired')
      .isCorrectLanguage(),
    stateNumber: Yup.string().required('validationErrors.isRequired'),
    transportManufacturer: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    transportModel: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    vin: Yup.string().required('validationErrors.isRequired'),
    applicantResidenceCountry: Yup.object()
      .nullable()
      .when('applicantIs', {
        is: (applicantIs) => applicantIs !== APPLICANT_TYPES[2].value,
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceState: Yup.object()
      .nullable()
      .when(['applicantResidenceCountry', 'applicantIs'], {
        is: (applicantResidenceCountry, applicantIs) => applicantIs !== APPLICANT_TYPES[2].value
          && isArmenianCountry(applicantResidenceCountry),
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceCityVillage: Yup.object()
      .nullable()
      .when(['applicantResidenceCountry', 'applicantIs'], {
        is: (applicantResidenceCountry, applicantIs) => applicantIs !== APPLICANT_TYPES[2].value
          && isArmenianCountry(applicantResidenceCountry),
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceStreet: Yup.string()
      .nullable()
      .when('applicantIs', {
        is: (applicantIs) => applicantIs !== APPLICANT_TYPES[2].value,
        then: Yup.string()
          .required('validationErrors.isRequired')
          .isCorrectLanguage(),
      }),
  })
  .concat(
    Yup.object().shape(
      getPhysicalEntityValidator({
        genderKey: 'applicantGender',
        when: 'applicantIs',
        is: (applicantIs) => applicantIs === APPLICANT_TYPES[1].value,
      }),
    ),
  )
  .concat(
    Yup.object().shape(
      getLegalEntityValidator({
        when: 'participantIs',
        is: (participantIs) => participantIs === ACCIDENT_PARTICIPANT_TYPES[2].value,
      }),
    ),
  )
  .concat(Yup.object().shape(getLegalEntityValidator()));

export default legalSchema;
